<template>
  <aw-dropdown
    placement="bottom-end"
    :offset="[0, 6]"
    class="relative cursor-pointer"
  >
    <template v-slot:btn="{ toggle }">
      <div
        @click="toggle"
        class="bg-white w-6 h-6 rounded-full text-bc-blue inline-flex items-center justify-center text-sm font-medium border border-bc-blue hover:bg-bc-blue hover:text-white"
      >
        {{ this.pos }}
      </div>
    </template>
    <template v-slot:dropdown="{ opened, dropdown }">
      <div
        v-show="opened"
        :ref="dropdown"
        class="Dropdown Dropdown--GalleryComment Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
      >
        <document-tooltip-bubble
          class="TooltipBubble--Show"
          style="position: static; transform: none; width: auto;"
        />
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
export default {
  props: ['pos'],
}
</script>

<style lang="scss" scoped></style>
